import React, { useState } from "react";
import { ChangePasswordSlice } from "../../redux/features/AccountManagement";
import { FaEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [iState, setUpdate] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [eyeState, setEyeUpdate] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdate((prev) => ({ ...prev, [name]: value }));
  };

  let getToken = null;

  try {
    const token = localStorage.getItem("single_vendor_admin_token");
    if (token) {
      getToken = jwtDecode(JSON.parse(token));
    }
  } catch (error) {
    getToken = null;
  }

  const handleSubmit = () => {
    if (iState?.oldPassword?.length === 0)
      return toast.error("Please enter old password!");
    if (iState?.newPassword?.length === 0)
      return toast.error("Please enter new password!");
    if (iState?.confirmPassword?.length === 0)
      return toast.error("Please enter confirm password!");

    //   const decodedToken = jwtDecode(JSON.parse(localStorage.getItem('Quixtoken')));
    if (iState?.newPassword === iState?.confirmPassword) {
      console.log("iState:", iState);
      const data = {
        id: getToken?.id,
        oldPassword: iState.oldPassword,
        password: iState?.newPassword,
      };
      dispatch(ChangePasswordSlice(data)).then((res) => {
        setUpdate({
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
        navigate("/");
      });
    } else {
      toast.error("new password and comfirm password not matched!");
    }
  };

  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="PasswordBox">
              <aside>
                <h4>Change Password</h4>
              </aside>
              <article style={{ marginBottom: "100px" }}>
                <div className="CommonForm">
                  <div className="form-group">
                    <label>Old Password</label>
                    <input
                      type={eyeState?.oldPassword ? "text" : "password"}
                      name="oldPassword"
                      value={iState?.oldPassword}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter Old Password"
                    />
                    <span
                      className="Icon"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setEyeUpdate((prev) => ({
                          ...prev,
                          oldPassword: !prev["oldPassword"],
                        }))
                      }
                    >
                      {eyeState?.oldPassword ? (
                        <i className="fa fa-eye" />
                      ) : (
                        <FaEyeSlash />
                      )}
                    </span>
                  </div>
                  <div className="form-group">
                    <label>New Password</label>
                    <input
                      type={eyeState?.newPassword ? "text" : "password"}
                      name="newPassword"
                      value={iState?.newPassword}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter New Password"
                    />
                    <span
                      className="Icon"
                      onClick={() =>
                        setEyeUpdate((prev) => ({
                          ...prev,
                          newPassword: !prev["newPassword"],
                        }))
                      }
                    >
                      {eyeState?.newPassword ? (
                        <i className="fa fa-eye" />
                      ) : (
                        <FaEyeSlash />
                      )}{" "}
                    </span>
                  </div>
                  <div className="form-group">
                    <label>Re-enter Password</label>
                    <input
                      type={eyeState?.confirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      value={iState?.confirmPassword}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter Re-enter Password"
                    />
                    <span
                      className="Icon"
                      onClick={() =>
                        setEyeUpdate((prev) => ({
                          ...prev,
                          confirmPassword: !prev["confirmPassword"],
                        }))
                      }
                    >
                      {eyeState?.confirmPassword ? (
                        <i className="fa fa-eye" />
                      ) : (
                        <FaEyeSlash />
                      )}{" "}
                    </span>
                  </div>
                  <button className="Button" onClick={handleSubmit}>
                    Update Password
                  </button>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
